import React, { useState } from 'react';

function HelpCenter({ onBack }) {
  const [openFaq, setOpenFaq] = useState(null);

  const faqs = [
    { q: 'How do I upload a medical report?', a: 'Go to Reports tab → tap Upload → select report type → choose file → submit. AI will automatically extract text from PDF reports.' },
    { q: 'How do I scan a prescription?', a: 'Go to Meds tab → tap the teal scan button → give a name to the prescription → upload photo → AI reads medicines automatically.' },
    { q: 'How do I share my records with a doctor?', a: 'Go to Access tab → when doctor sends a request, you\'ll see it here. Tap Approve to grant access. You can revoke anytime.' },
    { q: 'What is my Patient UID?', a: 'Your Patient UID (e.g. MHJ2024XXXXX) is your unique health ID. Doctors and labs use it to upload reports directly to your account.' },
    { q: 'How does the AI Summary work?', a: 'Go to AI tab → Generate Summary. Our AI reads all your uploaded reports and gives a simple health overview in plain language.' },
    { q: 'Is my health data safe?', a: 'Yes! All your data is encrypted with AES-256. Only you control who can access your records. We follow HIPAA compliance standards.' },
    { q: 'How do I delete a medication?', a: 'Go to Meds tab → find the medication → tap the delete (trash) icon → confirm deletion.' },
    { q: 'Can I download my reports?', a: 'Yes! Go to Reports tab → find the report → tap Download button to save it to your device.' },
  ];

  return (
    <div className="min-h-screen bg-[#F4F7FC]" style={{ fontFamily: 'Inter, sans-serif' }}>
      <div className="bg-white px-4 py-4 flex items-center gap-3 border-b border-gray-100 shadow-sm">
        <button onClick={onBack} className="w-9 h-9 flex items-center justify-center text-gray-500 hover:bg-gray-100 rounded-full">
          <span className="material-symbols-outlined">arrow_back</span>
        </button>
        <h1 className="font-black text-[#0D1B2A] text-lg">Help Center</h1>
      </div>

      <div className="px-4 py-5 space-y-4">
        {/* Hero */}
        <div className="bg-[#0B3C95] rounded-2xl p-5 text-white text-center">
          <span className="material-symbols-outlined text-white mb-2 block" style={{ fontSize: '40px', fontVariationSettings: '"FILL" 1' }}>support_agent</span>
          <p className="font-black text-lg">How can we help?</p>
          <p className="text-white/70 text-xs mt-1">Find answers to common questions below</p>
        </div>

        {/* Quick Links */}
        <div className="grid grid-cols-2 gap-3">
          {[
            { icon: 'upload_file', label: 'Upload Report', color: '#00A884', bg: '#E6F7F4' },
            { icon: 'document_scanner', label: 'Scan Prescription', color: '#0B3C95', bg: '#EAF2FF' },
            { icon: 'qr_code', label: 'Patient QR Code', color: '#8B5CF6', bg: '#F0EBFB' },
            { icon: 'shield', label: 'Privacy & Security', color: '#EF4444', bg: '#FEF2F2' },
          ].map(item => (
            <div key={item.label} className="bg-white rounded-2xl p-4 border border-gray-100 shadow-sm flex items-center gap-3">
              <div className="w-9 h-9 rounded-xl flex items-center justify-center shrink-0" style={{ background: item.bg }}>
                <span className="material-symbols-outlined" style={{ fontSize: '18px', color: item.color, fontVariationSettings: '"FILL" 1' }}>{item.icon}</span>
              </div>
              <p className="text-xs font-bold text-[#0D1B2A]">{item.label}</p>
            </div>
          ))}
        </div>

        {/* FAQs */}
        <div>
          <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-3">Frequently Asked Questions</p>
          <div className="space-y-2">
            {faqs.map((faq, i) => (
              <div key={i} className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
                <button onClick={() => setOpenFaq(openFaq === i ? null : i)}
                  className="w-full flex items-center justify-between px-4 py-4 text-left">
                  <p className="text-sm font-bold text-[#0D1B2A] flex-1 pr-2">{faq.q}</p>
                  <span className="material-symbols-outlined text-gray-400 shrink-0" style={{ fontSize: '20px' }}>
                    {openFaq === i ? 'expand_less' : 'expand_more'}
                  </span>
                </button>
                {openFaq === i && (
                  <div className="px-4 pb-4 border-t border-gray-50">
                    <p className="text-sm text-gray-500 leading-relaxed pt-3">{faq.a}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Contact */}
        <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-4">
          <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-3">Still need help?</p>
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-[#0B3C95]/10 rounded-xl flex items-center justify-center shrink-0">
              <span className="material-symbols-outlined text-[#0B3C95]" style={{ fontSize: '20px' }}>mail</span>
            </div>
            <div>
              <p className="text-sm font-bold text-[#0D1B2A]">Email Support</p>
              <p className="text-xs text-[#0B3C95]">support@myhealthjournal.in</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HelpCenter;